import type { UnknownAction } from 'redux';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './paymentMethodsActions';
import { PAYMENT_METHODS_REDUCER_KEY, type PaymentMethodProps } from './paymentMethodsTypes';

const mkPaymentMethodsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<PaymentMethodProps>();
const initialState = mkPaymentMethodsStore();

function paymentMethodsReducer(state = initialState, action: UnknownAction): typeof state {
  switch (true) {
    case actions.getPaymentMethods.match(action):
      return state.set('isLoading', true);
    case actions.getPaymentMethodsSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getPaymentMethodsFailure.match(action):
      return resourceUpserters.completeWithError<PaymentMethodProps>(state, action.payload);
    default:
      return state;
  }
}

export { PAYMENT_METHODS_REDUCER_KEY };
export default paymentMethodsReducer;
